import {observer} from "mobx-react";
import {Page} from "../../ui";
import {DialogStore, FmsModalDialogPrintStore, fmsPackageDetailStore} from "../../../store";
import {useState} from "react";
import {ShipmentPackageStatusDto} from "../../../api/fms";
import "./FmsPackageDetailPage.scss"
import {FmsDetailIntro} from "./FmsDetailIntro";
import {FmsModalDialogDocumentNotLocatable} from "./FmsModalDialogDocumentNotLocatable";
import {FmsModalDialogCancelDocument} from "./FmsModalDialogCancelDocument";
import {FmsPackageDetailTable} from "./FmsPackageDetailTable";
import {FmsPackageDetailActions} from "./FmsPackageDetailActions";
import {FmsModalDialogShipmentType} from "./FmsModalDialogShipmentType";
import {FmsModalDialogReceiver} from "./FmsModalDialogReceiver";
import {FmsModalDialogPrintDocument} from "./FmsModalDialogPrintDocument";

const FmsPackageDetailPage = observer(function FmsPackageDetailPage() {
    const [notLocatableDialogStore] = useState(new DialogStore())
    const [cancelDocumentDialog] = useState(new DialogStore())
    const [printDocumentDialog] = useState(new FmsModalDialogPrintStore())
    const [shipmentTypeDialogStore] = useState(new DialogStore())
    const [receiverDialogStore] = useState(new DialogStore())
    const [vinToPrint, setVinToPrint] = useState<string | undefined>()
    const items = fmsPackageDetailStore.data?.items || []
    const closed = fmsPackageDetailStore.data?.status === ShipmentPackageStatusDto.CLOSED

    return <Page
        cssSuffix={`fms ${closed ? 'closed' : ''}`}
        breadcrumb={[
            {
                link: '/fms',
                label: 'Versand'
            },
            {
                link: `/fms/packages`,
                label: 'Versandpakete'
            },
            {
                link: `/fms/packages/${fmsPackageDetailStore.id}`,
                label: 'Detailansicht'
            }
        ]}
        action={<FmsPackageDetailActions/>}
        topper={<FmsDetailIntro
            shipmentTypeDialogStore={shipmentTypeDialogStore}
            receiverDialogStore={receiverDialogStore}
        />}
    >
        <>
            <FmsModalDialogDocumentNotLocatable store={notLocatableDialogStore}/>
            <FmsModalDialogCancelDocument store={cancelDocumentDialog}/>
            <FmsModalDialogPrintDocument
                store={printDocumentDialog}
                action={async (printerId) => {
                    if (vinToPrint) {
                        await fmsPackageDetailStore.printCoverLetter(vinToPrint, printerId)
                    }
                }}
            />
            <FmsModalDialogShipmentType store={shipmentTypeDialogStore}/>
            <FmsModalDialogReceiver store={receiverDialogStore}/>
            <FmsPackageDetailTable
                items={items}
                cancelDocumentDialog={cancelDocumentDialog}
                notLocatableDialogStore={notLocatableDialogStore}
                reprintCoverLetter={vinV => {
                    setVinToPrint(vinV)
                    printDocumentDialog.dialogOpen = true
                }}
            />
        </>
    </Page>
})

export {
    FmsPackageDetailPage
}
